<!--/*
 * Copyright (c) 2020 The Awareness Company. All rights reserved. 
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */ -->
<template>
<div>
  <apexchart type="bar" height="310" :options="chartOptions" :series="series" />
</div>  
</template>

<script>
export default {
  name: "ConfirmedPopulation",
  data: () => ({
    series: [
      {
        name: "series1",
        data: []
      }
    ],
    chartOptions: {
      theme: {
        mode: "dark",
        palette: "palette1"
      },
      colors: ["#e91e63", "#A300D6", "#008FFB", "#F86624", "#d6c51b", "#61c1a1", "#53aeb6", "#da80b1", "#28b4c9", "#7c6ea7"],
      chart: {
        background: "rgb(28, 42, 82)",
        foreColor: "rgb(212, 212, 212)",
        toolbar: {
          show: true,
          tools: {
            download: false,
            selection: false
          },
          autoSelected: "zoom"
        }
      },
      grid: {
        borderColor: "rgb(27, 36, 77)"
      },
      title: {
        text: "Top 10 Most Confirmed Per 100 000 Population",
        offsetY: 10,
        align: 'center',
        style: {
          fontSize: "16px",
          fontWeight: 600
        }
      },
      legend: {
        show: false,
        position: "bottom",
        itemMargin: {
          vertical: 10
        }
      },
      markers: {
        size: 2
      },
      plotOptions: {
        bar: {
          columnWidth: "50%",
          distributed: true
        }
      },
      xaxis: {
        categories: [],
        labels: {
          style: {
            fontSize: "10px"
          }
        }
      }
    }
  }),
  methods: {
    loadCases(data, countryDisplay) {

      this.series[0].data = [];

      //loop through each country and find it's last new cases
      var countries = []
      for (var i = 0; i < data.length; i++) {
        
        //calculate the latest confirmed per 100k population
        var latestconfirmed = data[i].cases[data[i].cases.length - 1].cumulative_cases
        var totalpop = data[i].population.population*1

        var per100k = (latestconfirmed/totalpop) * 100000
        per100k = parseFloat(per100k.toFixed(0))

        countries.push({
          country: data[i].Country_WHO,
          per100k: per100k
        })
      }

      //sort by count desc
      countries = countries.sort(function(a, b) {
        a = a.per100k;
        b = b.per100k;
        return a > b ? -1 : a < b ? 1 : 0;
      });

      //only take the top 10
      countries = countries.slice(0, 10);

      //loop and extract cols and vals
      var cols = [];
      var vals = [];

      for (var i = 0; i < countries.length; i++) {
        cols.push(countries[i].country);
        vals.push(countries[i].per100k);
      }

      //set the graph data
      this.series = [{ name: "Confirmed per 100k population", data: vals }];
      this.chartOptions = {
        xaxis: {
          categories: cols
        }
      };
    },
    resize() {
      let self = this;
      this.$nextTick().then(function() {
        self.chartOptions = {
          chart: {
            height: "310"
          }
        };
      });
    }
  }
};
</script>
